<template>
  <FormSubmitPopup
    :title="title"
    v-model="value"
    :rightMethod="onSubmitted"
    :rightButtonDisabled="isAutoGetRate && !autoGetRateComplete"
    @popupClose="$emit('input', false)"
    :rightButtonText="$t('submit')"
    ref="formPopup"
    hasAlert
    :classes="['labelPopup']"
    large>
    <template v-slot:input>
      <v-container py-0 fluid>
        <v-layout row>
          <v-flex xs12>
            <v-autocomplete
              hide-details
              :items="labelTemplates"
              return-object
              :label="$t('template')"
              item-text="name"
              @change="applyLabelTemplate"
            ></v-autocomplete>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text style="padding-top: 5px">
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('sender') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details
                      :items="fromAddress"
                      return-object
                      :label="$t('addressName')"
                      v-model="fromTemplate"
                      item-text="siteName"
                      @change="address => {
                        if (address.siteId) {
                          from.siteId = address.siteId
                        } else {
                          delete from.siteId
                        }
                      }"
                      item-value="key"></vite-autocomplete>
                  </v-flex>
                  <!-- <v-flex md4 v-if="hasHazmatFeatures">
                    <v-checkbox
                      hide-details
                      :label="$t('sendHazmat')"
                      v-model="isSupportDangerousGoods"
                      class="checkbox"
                      @change="clearFromTemplate"
                    ></v-checkbox>
                  </v-flex> -->
                  <v-flex md6>
                    <v-checkbox v-if="!isSupportDangerousGoods && !isFreight" hide-details :label="$t('save')" v-model="isSaveFrom" class="checkbox"></v-checkbox>
                  </v-flex>
                  <v-flex md6>
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowFromParseAddress', 'parseFormAddress', from)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md6  v-if="isSaveFrom">
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="from.siteName"
                      v-if="isSaveFrom && !isSupportDangerousGoods"
                      :rules="[ fieldIsRequired('Site name'),  v => v === to.siteName && isSaveTo ? $t('siteNameIsSameAsToSite') : true]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowFromParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseFormAddress"
                    @input="e => changeAddress(e, 'from')"
                    outline
                    rows="3"
                    hide-details
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="from.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportFromExt, xs12: !currentShippingService.isSupportFromExt }">
                            <v-text-field
                              hide-details
                              :label="$t('phone')"
                              v-model.trim="from.phone"
                              class="required_field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportFromExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="from.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('companyName')"
                      v-model.trim="from.company"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="from.address1"
                      :readonly="isSupportDangerousGoods || isFreight"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('Address1', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="from.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="from.city"
                          :rules="[fieldIsRequired('City')]"
                          :readonly="isSupportDangerousGoods || isFreight"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <vite-autocomplete
                          hide-details
                          :items="states"
                          v-model="from.state"
                          :label="$t('state')"
                          :rules="[fieldIsRequired('State')]"
                          :readonly="isSupportDangerousGoods || isFreight"
                          class="required_field"
                        >
                          <template v-slot:item="data">
                            <template>
                              <v-list-tile-content>
                                <v-list-tile-title :id="data.item">
                                  {{data.item}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </vite-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('zipCode')"
                      v-model.trim="from.zipCode"
                      :readonly="isSupportDangerousGoods || isFreight"
                      :rules="[fieldIsRequired('Zip code')]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex md6>
            <v-card width="100%">
              <v-card-text style="padding-top: 5px">
                <v-layout align-baseline>
                  <v-flex class="title" md3>{{ $t('recipient') }}: </v-flex>
                  <v-flex md4>
                    <vite-autocomplete
                      hide-details
                      :items="addresses"
                      return-object
                      :label="$t('addressName')"
                      v-model="toTemplate"
                      item-text="siteName"
                      item-value="siteName"></vite-autocomplete>
                  </v-flex>
                  <v-flex md2>
                    <v-checkbox hide-details :label="$t('save')" v-model="isSaveTo" class="checkbox"></v-checkbox>
                  </v-flex>
                  <v-flex md3>
                    <v-btn flat color="primary" @click="toggleParseAddress('isShowToParseAddress', 'parseToAddress', to)">{{$t('parseAddress')}}</v-btn>
                  </v-flex>
                  <v-flex md6 v-if="isSaveTo">
                    <v-text-field
                      hide-details
                      :label="$t('addressName')"
                      v-model.trim="to.siteName"
                      v-if="isSaveTo"
                      :rules="[ fieldIsRequired('Site name'),  v => v === from.siteName && isSaveFrom? $t('siteNameIsSameAsToSite') : true]"
                      class="required_field"></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout v-if="isShowToParseAddress">
                  <v-textarea
                    :label="$t('fullAddress')"
                    v-model.trim="parseToAddress"
                    outline
                    rows="3"
                    hide-details
                    @input="e => changeAddress(e, 'to')"
                  >
                  </v-textarea>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('fullName')"
                          v-model.trim="to.fullName"
                          :rules="[ fieldIsRequired('Full name'), fieldCharLimit('Full name', 35) ]"
                          class="required_field"
                        />
                      </v-flex>
                      <v-flex xs5>
                        <v-layout justify-space-between>
                          <v-flex v-bind="{ xs7: currentShippingService.isSupportToExt, xs12: !currentShippingService.isSupportToExt }">
                            <v-text-field
                              hide-details
                              :label="$t('phone')"
                              v-model.trim="to.phone"
                              class="required_field"
                            ></v-text-field>
                          </v-flex>
                          <v-flex v-if="currentShippingService.isSupportToExt" xs4>
                            <v-text-field
                              hide-details
                              :label="$t('extension')"
                              v-model.trim="to.extension"
                              :rules="[fieldCharLimit('extension', 6)]"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="$t('companyName')"
                      v-model.trim="to.company"
                    />
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 1`"
                      v-model.trim="to.address1"
                      :rules="[fieldIsRequired('Address'), fieldCharLimit('address', 50)]"
                      class="required_field"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      hide-details
                      :label="`${$t('address')} 2`"
                      :rules="[fieldCharLimit('Address2', 50)]"
                      v-model.trim="to.address2"
                      ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-space-between>
                  <v-flex xs7>
                    <v-layout justify-space-between>
                      <v-flex xs5>
                        <v-text-field
                          hide-details
                          :label="$t('city')"
                          v-model.trim="to.city"
                          :rules="[fieldIsRequired('City')]"
                          class="required_field"
                          ></v-text-field>
                      </v-flex>
                      <v-flex xs5>
                        <vite-autocomplete
                          hide-details
                          :items="states"
                          v-model="to.state"
                          :label="$t('state')"
                          :rules="[fieldIsRequired('State')]"
                          class="required_field"
                        >
                          <template v-slot:item="data">
                            <template>
                              <v-list-tile-content>
                                <v-list-tile-title :id="data.item">
                                  {{data.item}}
                                </v-list-tile-title>
                              </v-list-tile-content>
                            </template>
                          </template>
                        </vite-autocomplete>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs4>
                    <v-layout justify-space-around align-baseline>
                      <v-flex>
                        <v-text-field
                          hide-details
                          :label="$t('zipCode')"
                          v-model.trim="to.zipCode"
                          :rules="[fieldIsRequired('Zip code')]"
                          class="required_field"></v-text-field>
                      </v-flex>
                      <v-flex xs2>
                        <v-tooltip top>
                          <template v-slot:activator="{on}">
                            <v-btn :disabled="googleMapDisabled" icon flat v-on="on" color="primary" @click.stop="goToGoogleMapLink" small><v-icon>location_on</v-icon></v-btn>
                          </template>
                          <span> {{ $t('googleMap') }}</span>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <div>
                  <v-layout justify-end align-center>
                    <v-btn flat color="primary" small :disabled="disabledAddressValidation" :loading="verificationAddressLoading" @click="verificationAddress">{{ $t('addressVerification') }}</v-btn>
                  </v-layout>
                  <v-layout justify-end align-center>
                    <!-- <v-flex v-if="toAddressValidationInfo" style="color: #ffa000"></v-flex> -->
                    <v-flex v-if="toAddressValidationInfo" style="text-align: right">
                      <span style="color: #ffa000;text-align: right">{{ toAddressValidationInfo.addressType }}</span>
                      <span>{{ $t('recommendAddress') }}: {{ recommendAddressFormatFunc(toAddressValidationInfo.recommendAddress) }}</span>
                      <v-btn small flat color="primary" @click="() => to = { ...to, ...toAddressValidationInfo.recommendAddress }">{{ $t('apply') }}</v-btn>
                    </v-flex>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row v-if="hasHazmatFeatures && isLabelServiceSupportDangerousGoods">
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <HazardousCommodities
                  v-model="hazMatsInfo"
                  :dangerousGoods.sync="dangerousGoods"
                  :offerorName.sync="offerorName"
                  :emergencyContactNumber.sync="emergencyContactNumber"
                  :dryIceWeight.sync="dryIceDetail.weight"
                  :dryIceUnit.sync="dryIceDetail.unit"
                  :filterItems="['', 'LITHIUM_BATTERY']"
                  :isPrintSafetyDocument.sync="isPrintSafetyDocument"
                  :signatureCode.sync="signatureCode"
                  ref="HazardousCommodities"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex>
            <v-card width="100%">
              <v-card-text>
                <LabelPackageWidget
                  v-if="!isFreight"
                  ref="LabelPackageWidget"
                  :to="to"
                  :packages.sync="packages"
                  :noteMemoSignature='noteMemoSignature'
                  :shippingService.sync="shippingService"
                  :carrier.sync="carrier"
                  :carriers.sync="carriers"
                  :autoGetRateComplete="autoGetRateComplete"
                  :initLabelStockType="labelInfo.labelStockType"
                  :initIsSaturdayDelivery="labelInfo.isSaturdayDelivery"
                  :fromState="from.state"
                  :order="order"
                  :dangerousGoods="dangerousGoods"
                  @clearDangerousGoods="clearDangerousGoods"
                  @selectTemplate="selectTemplate"
                />
                <LabelFreightPkgWidget
                  v-else
                  ref="LabelPackageWidget"
                  :packages.sync="packages"
                  :noteMemoSignature='noteMemoSignature'
                  :shippingService.sync="shippingService"
                  :carrier.sync="carrier"
                  :initLabelStockType="labelInfo.labelStockType"
                  :initIsSaturdayDelivery="labelInfo.isSaturdayDelivery"
                  :fromState="from.state"
                  @selectTemplate="selectTemplate"
                  :isFreight="isFreight"
                />
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout column>
          <v-flex>
            <v-layout justify-end align-baseline>
              <v-flex xs6 md2 v-if="false">
                <v-text-field
                  :label="$t('duplicateShipments')"
                  v-model.number="quantity"
                  :rules="[
                    fieldIsRequired('quantity'),
                    fieldIsInteger('quantity'),
                    fieldIsOverZero('quantity'),
                    limitMultipleShipping
                  ]"
                  class="required_field"></v-text-field>
              </v-flex>
              <v-flex v-if="serviceSetting.cancelHint" xs4 md3 text-xs-center style="border: 1px solid black; border-radius: 2px;">
                {{ $t(serviceSetting.cancelHint) }}
              </v-flex>
              <v-flex xs8>
                <v-layout align-baseline justify-end>
                  <v-flex v-if="autoGetRateComplete && isAutoGetRate" md3 mr-5>
                    <span>{{  $t('selectedShippingService') + ': ' }}</span>
                    <span class="font-weight-black">{{ displayRate.serviceDescription }}</span>
                  </v-flex>
                  <v-flex md2><v-btn color="primary" :disabled="isLoadingRates" @click.stop="getRate">{{ $t('getRate') }}</v-btn></v-flex>
                  <v-flex md9>
                    <v-layout>
                      <v-flex md2 v-if="isLoadingRates">
                        <v-progress-circular
                          indeterminate
                          color="primary"></v-progress-circular>
                      </v-flex>
                      <v-flex md10 v-else>
                        <v-layout row no-wrap text-xs-center>
                          {{ $t('baseCharge') }}: $ {{ displayRate.rate || '----' }}
                          <span v-if="displayRate.surcharge">
                          &nbsp;&nbsp;
                            {{ $t('surcharge') }}: $ {{ displayRate.surcharge === null ? '----' : displayRate.surcharge }}
                          </span>
                          <small v-if="displayRate.hasResidentialCheck" style="color: blue;">{{
                            $t(displayRate.isResidential ? "residential" : 'commercial')
                          }}</small>
                          <span v-if="displayRate.surcharge">
                            &nbsp;&nbsp;
                            {{ $t('total') }}: $ {{ displayRate.rate ? toMoney(displayRate.rate + displayRate.surcharge) : '----' }}
                          </span>
                          &nbsp;&nbsp;&nbsp;
                          <span v-if="displayRate.estimatedDelivery && displayRate.estimatedDelivery !== 'N/A' && !['xs', 'sm', 'md'].includes($vuetify.breakpoint.name)">
                            {{ $t('estDelivery') }}: {{ formatEstDeliveryDate(displayRate.estimatedDelivery) }}
                          </span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex md2 v-if="rates.length > 1 && !isLoadingRates" class="subheading font-weight-bold">
                    <!-- more Rates -->
                    <v-menu
                      v-model="moreRatesToggle"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >

                      <template v-slot:activator="{ on }">
                        <v-btn
                          dark
                          color="primary"
                          flat
                          v-on="on"
                        > More rates
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-text>
                          <div style="height: 500px; overflow: auto;">
                            <v-data-table
                              :headers="[
                                { text: $t('service'), align: 'left', sortable: false, value: 'serviceType' },
                                { text: `${$t('baseCharge')} ($)`, align: 'left', sortable: false, value: 'rate' },
                                { text: `${$t('surcharge')} ($)`, align: 'left', sortable: false, value: 'surcharge'},
                                { text: `${$t('total')} ($)`, align: 'left', sortable: false, value: 'total'},
                                { text: $t('estDelivery'), align: 'left', sortable: false, value: ''}
                              ]"
                              :items="rates"
                              item-key="serviceType"
                              hide-actions
                            >
                              <template v-slot:items="{ item }">
                                <td ><a linkify @click="switchShippingService(item)">{{ item.serviceDescription || item.serviceType }}</a></td>
                                <template v-if="item.message">
                                  <td colspan="4">{{item.message}}</td>
                                </template>
                                <template v-else>
                                  <td>{{ item.rate }}</td>
                                  <td>{{ item.surcharge || 'N/A' }}</td>
                                  <td>{{ item.total }}</td>
                                  <td>
                                    {{ formatEstDeliveryDate(item.estimatedDelivery) }}
                                  </td>
                                </template>
                              </template>
                            </v-data-table>
                          </div>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="primary" flat @click="moreRatesToggle = false" >{{ $t('close') }}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout v-if="errorMessage">
              <v-flex class="red--text font-weight-bold text-xs-right">
                {{errorMessage}}
              </v-flex>
            </v-layout>
            <v-layout v-if="Object.keys(warningMessages).length" justify-end>
              <span class="font-weight-bold text-xs-right" style="background-color: yellow;">
                {{Object.values(warningMessages).join(', ')}}
              </span>
            </v-layout>
            <v-layout v-if="recommendAddress" align-baseline justify-end>
              <v-flex xs8 style="display: flex;">
                <v-flex style="flex: 1"></v-flex>
                <div class="font-weight-bold" style="padding: 0px 5px; display: flex; align-items: center; background-color: yellow;">
                  {{ $t('recommendAddress') }}: {{ recommendAddressFormat }}
                </div>
                <v-flex md2>
                  <v-btn color="primary" flat @click="useRecommendAddress" style="margin: 0px 6px">{{$t('apply')}}</v-btn>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
      <!-- <FormSubmitPopup
        :title="$t('parseAddress')"
        v-model="isShowParseAddressPopup"
        :rightMethod="applyData"
        :leftMethod="closePopupAndResetData"
        :rightButtonText="$t('confirm')"
        hasAlert
        medium
        >
        <template v-slot:input>
          <v-container>
            <v-layout v-if="parseErrorMessage">
              <v-flex class="red--text font-weight-bold text-xs-left">
                {{parseErrorMessage}}
              </v-flex>
            </v-layout>
            <v-layout column>
              <v-flex>
                <v-layout row>
                  <v-flex md10>
                    <v-textarea
                      :label="$t('fullAddress')"
                      v-model.trim="originAddress"
                      @keyup.enter.prevent="parseAddressStr"
                      outline
                      rows="3"
                      class="thinBox"
                      persistent-hint></v-textarea>
                  </v-flex>
                  <v-flex>
                    <v-layout row align-center>
                      <v-flex md10 xs10>
                        <v-btn flat @click="parseAddressStr">{{$t('parse')}}</v-btn>
                      </v-flex>

                      <template>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn icon small v-on="on">
                              <v-icon>help</v-icon>
                            </v-btn>
                          </template>
                          <span>
                            Address Format Guidelines: <br>
                            1. First Line (Optional): Name of the individual (if applicable).<br>
                            2. Second Line (Optional): Company Name (if applicable).<br>
                            3. Third Line: Street Address.<br>
                            4. Fourth Line: City, State, and ZIP Code.<br>
                            5. Final Line: Phone number (if applicable).<br><br>
                            Address Template Example: <br>
                            [Name (if applicable)]<br>
                            [Company Name (if applicable)]<br>
                            [Street Address]<br>
                            [City, State - ZIP Code]<br>
                            [Phone Number (if applicable)]<br><br>
                            Example Address:<br>
                            John Doe<br>
                            Acme Corporation<br>
                            8403 Country Shire Ln<br>
                            Spring Grove, IL - 60081<br>
                            8156756877
                          </span>
                        </v-tooltip>
                      </template>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-layout justify-space-between>
                  <v-flex md3>
                    <v-text-field
                      hide-details
                      :label="$t('fullName')"
                      v-model.trim="parseAddressData.fullName">
                    </v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      hide-details
                      :label="$t('phone')"
                      v-model.trim="parseAddressData.phone">
                    </v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      hide-details
                      :label="$t('companyName')"
                      v-model.trim="parseAddressData.company">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex>
                <v-text-field
                  hide-details
                  :label="`${$t('address')} 1`"
                  v-model.trim="parseAddressData.address1">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-text-field
                  hide-details
                  :label="$t('address2')"
                  v-model.trim="parseAddressData.address2">
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-layout justify-space-between>
                  <v-flex md4>
                    <v-text-field
                      hide-details
                      :label="$t('city')"
                      v-model.trim="parseAddressData.city">
                    </v-text-field>
                  </v-flex>
                  <v-flex md4>
                    <v-text-field
                      hide-details
                      :label="$t('state')"
                      v-model.trim="parseAddressData.state">
                    </v-text-field>
                  </v-flex>
                  <v-flex md3>
                    <v-text-field
                      hide-details
                      :label="$t('zipCode')"
                      v-model.trim="parseAddressData.zipCode">
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </template>
      </FormSubmitPopup> -->
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import LabelPackageWidget from './LabelPackageWidget'
import LabelFreightPkgWidget from './LabelFreightPkgWidget'
import HazardousCommodities from './HazardousCommodities'
import { timeTools, checkRules, cloneDeep, toMoney, gotoGoogleMap, measurementTools, calculateQtyMethod, parseAddress, toPickerDateString } from '@/utils/tools'
import { PRICING_OPTIONS } from '@/utils/const'

const addressArr = [
  ['fullName', 'phone', 'company'],
  ['address1', 'address2'],
  ['city', 'state', 'zipCode']
]

export default {
  name: 'LabelCreatePopup',
  components: {
    FormSubmitPopup,
    LabelPackageWidget,
    LabelFreightPkgWidget,
    HazardousCommodities
  },
  mixins: [
    checkRules,
    timeTools,
    measurementTools,
    calculateQtyMethod
  ],
  data () {
    return {
      title: this.$t(this.isFreight ? 'createFreightLabel' : 'createLabel'),
      packaging: '',
      signature: false,
      menu: false,
      newSenderName: '',
      from: {
        address1: '',
        city: '',
        state: '',
        zipCode: ''
      },
      fromTemplate: {},
      to: {
        address1: '',
        city: '',
        state: '',
        zipCode: ''
      },
      toTemplate: {},
      rate: null,
      surcharge: null,
      insuredValue: 0,
      isLoadingRates: false,
      isSaveFrom: false,
      isSaveTo: false,
      quantity: 1,
      memo: '',
      note: '',
      errorMessage: '',
      warningMessages: {},
      name: '',
      rates: [],
      moreRatesToggle: false,
      shippingService: '',
      carrier: '',
      carriers: [],
      packages: [],
      requestIdCache: [],
      noteMemoSignature: {},
      dangerousGoods: '',
      hazMatsInfo: [],
      offerorName: '',
      emergencyContactNumber: '',
      dryIceDetail: {
        weight: '',
        unit: ''
      },
      isPrintSafetyDocument: true,
      signatureCode: null,
      isSupportHazmat: false,
      isShowParseAddressPopup: false,
      isShowFromParseAddress: false,
      parseFormAddress: '',
      isShowToParseAddress: false,
      parseToAddress: '',
      originAddress: '',
      parseAddressData: {},
      target: '',
      parseErrorMessage: '',
      autoGetRateComplete: false,
      recommendAddress: null,
      verificationAddressLoading: false,
      toAddressValidationInfo: null
    }
  },
  computed: {
    disabledAddressValidation () {
      const { address1, city, state, zipCode } = this.to
      return !(address1 && city && state && zipCode)
    },
    currentShippingService () {
      const res = this.labelServices.find(service =>
        service.serviceTypes.some(serviceType => this.shippingService === serviceType.value)
      ) || {}
      return res
    },
    shippingServices () {
      return this.$store.getters.shippingServices
    },
    isSupportDangerousGoods: {
      get () {
        return this.hasHazmatFeatures &&
          !!this.dangerousGoods
      },
      set (value) {
        this.isSupportHazmat = value
      }
    },
    hasHazmatFeatures () {
      return true
      // return this.visibleBetaFeatures.includes('hazmat')
    },
    fromAddress () {
      const addresses = this.addresses
      return this.isFreight
        ? this.$store.getters.freightSites
        : this.isSupportDangerousGoods
          ? this.hazmatSites
          : addresses
    },
    hazmatSites () {
      return this.$store.getters.hazmatSites
    },
    visibleBetaFeatures () {
      return this.$store.getters.visibleBetaFeatures
    },
    states () {
      const { supportParticularStates = [] } = this.currentShippingService || {}
      return this.$store.getters.stateAbbrevs.concat(supportParticularStates)
    },
    addresses () {
      return this.$store.getters.tenantAddresses
    },
    packagingMap () {
      return this.$store.getters.packagingMap
    },
    labelServices () {
      return this.$store.getters.labelServices.filter(ls => !this.from.state || (!(ls.allowedFromStates || []).length || ls.allowedFromStates.includes(this.from.state)))
    },
    systemBalance () {
      return this.$store.getters.systemBalance
    },
    clientKey () {
      return this.$store.getters.activeOrganization
    },
    displayRate () {
      let rate = this.rates.find(({serviceType, carrier, channel}) =>
        carrier.toLowerCase() === this.shippingService.toLowerCase() ||
        serviceType.toLowerCase() === this.shippingService.toLowerCase() ||
        (this.shippingService === 'FEDEX_MWT - MWT_GENERAL' && ['GROUND_HOME_DELIVERY', 'FEDEX_GROUND'].includes(serviceType.toUpperCase())) ||
        (this.shippingService === 'FEDEX_GROUND' && serviceType === 'GROUND_HOME_DELIVERY') ||
        (() => {
          const [shippingServiceType, shippingServiceChannel] = this.shippingService.split(' - ')
          const [rateServiceType, rateChannel = channel] = serviceType.split(' - ')
          return shippingServiceChannel === rateChannel && (
            carrier.toLowerCase() === shippingServiceType.toLowerCase() ||
            rateServiceType.toLowerCase() === shippingServiceType.toLowerCase() ||
            ['GROUND_HOME_DELIVERY', 'FEDEX_GROUND'].includes(rateServiceType.toUpperCase())
          )
        })()
      )
      if (!rate && ['mGIfq5pPDCUHIotTTkhQ', '9QgkBtPZAlXDdmwjxQoT'].includes(this.clientKey)) {
        rate = this.rates[0]
      }
      return rate || {}
    },
    limitMultipleShipping () {
      if (this.packages.reduce((acc, pkg) => acc + pkg.qty, 0) === 1) return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
      if (this.shippingService !== 'USPS') {
        return (v) => v <= 1 || this.$t('multipleShippingAreOnlySupportedForUsps')
      }
      return (v) => v <= 5 || this.$t('limitedLabelNum', { num: 5 })
    },
    isMeasurementMetric () {
      return !!this.$store.getters.isMeasurementMetric
    },
    googleMapDisabled () {
      return !(
        this.to && (
          this.to.address1 &&
          this.to.city &&
          this.to.state &&
          this.to.zipCode
        )
      )
    },
    serviceSetting () {
      return this.$store.getters.getLabelServiceSettingByCarrierAndServiceTypeValue(this.carrier, this.shippingService)
    },
    isLabelServiceSupportDangerousGoods () {
      return this.labelServices.some(service => {
        const labelService = service.serviceTypes.find(type => type.value === this.shippingService)
        return labelService
          ? labelService.hasOwnProperty('isSupportDangerousGoods')
            ? labelService.isSupportDangerousGoods
            : service.isSupportDangerousGoods
          : false
      })
    },
    allCities () {
      return this.$store.getters.allCities || {}
    },
    isAutoGetRate () {
      return this.carriers.length > 0
    },
    recommendAddressFormat () {
      return this.recommendAddressFormatFunc(this.recommendAddress)
    },
    labelTemplates () {
      return (this.$store.getters.labelTemplates || []).filter(item => item.businessType === this.businessType)
    }
  },
  beforeMount () {
    const {note, memo, signature, shippingService, packageType} = this.labelInfo
    // const [serviceType, channel = ''] = shippingService.split(' - ')
    if (shippingService) {
      const actualService = this.shippingServices.find(service => service.value === shippingService)
      if (actualService) {
        this.shippingService = actualService.value
      } else {
        // const service = channel.toUpperCase().includes('MWT')
        //   ? `FEDEX_MWT - ${channel}`
        //   : `${serviceType} - ${channel}`
        // this.shippingService = service
      }
    }
    if (note || memo || signature || packageType) Object.assign(this.noteMemoSignature, {note, memo, signature, packageType})
  },
  mounted () {
    if (this.labelInfo.packages && this.labelInfo.packages.length) {
      Object.assign(this, this.labelInfo)
      const { dangerousGoodsInfo } = this.labelInfo
      const isFedexMwt = this.labelInfo.shippingService === 'FEDEX_MWT - MWT_GENERAL'
      if (this.isSupportHazmat && dangerousGoodsInfo) {
        const { signatureCode, ...restDangerousGoodsInfo } = dangerousGoodsInfo
        Object.assign(this, restDangerousGoodsInfo)
        if (signatureCode && typeof signatureCode === 'string') {
          this.signatureCode = {
            downloadURL: signatureCode
          }
        } else {
          this.signatureCode = signatureCode || null
        }
      }
      this.packages = this.calAndAddQtyfromHistoryPkgs(this.packages, isFedexMwt)
    } else {
      this.applyDefaultLabelTemplate()
    }
    if (Object.keys(this.initTo).length) this.to = this.initTo
    if (this.labelInfo.from && Object.keys(this.labelInfo.from).length) this.from = this.labelInfo.from
  },
  watch: {
    toTemplate (value) {
      this.to = cloneDeep(this.toTemplate)
    },
    fromTemplate (value) {
      this.from = cloneDeep(this.fromTemplate)
    },
    shippingService (value) {
      if (!this.serviceSetting.enableInsured) {
        this.quantity = 1
        this.packages && this.packages.forEach(pkg => {
          pkg.insuredValue = 0
        })
      }
    }
  },
  methods: {
    clearDangerousGoods () {
      this.isPrintSafetyDocument = true
      this.dangerousGoods = ''
      this.signatureCode = ''
    },
    applyLabelTemplate (template) {
      if (!template) return
      if (template.from && Object.keys(template.from).length) this.from = cloneDeep(template.from)
      if (template.to && Object.keys(template.to).length) this.to = cloneDeep(template.to)
      this.selectTemplate(template)
      this.$nextTick(() => {
        const widget = this.$refs['LabelPackageWidget']
        if (widget && widget.onSelectTemplate) {
          widget.onSelectTemplate(template)
          if (template.shipDate) {
            widget.shipDate = toPickerDateString(new Date(template.shipDate))
          }
        }
      })
    },
    applyDefaultLabelTemplate () {
      const defaultTemplate = this.$store.getters.defaultLabelTemplateByType(this.businessType)
      if (defaultTemplate) this.applyLabelTemplate(defaultTemplate)
    },
    toggleParseAddress (name, textName, addressInfo) {
      const value = this[name]
      if (!value) {
        this[name] = true
        let address = ''
        addressArr.forEach(items => {
          items.forEach((item, index) => {
            if (address && ![items.length, 0].includes(index)) address += ','
            address += addressInfo[item] || ''
          })
          address += '\n'
        })
        if (!address.replace(/,/g, '').trim()) return
        this[textName] = address
      } else {
        this[name] = false
      }
    },
    changeAddress (e, name) {
      const lineData = e.split(/\n|\t/)
      addressArr.forEach((items, index) => {
        const data = lineData[index]?.split(',') || []
        items.forEach((item, i) => {
          let target = data[i]
          if (!target) return
          if (item === 'state') target = target?.toUpperCase() || ''
          this[name][item] = target?.trim() || ''
        })
      })
    },
    recommendAddressFormatFunc (address) {
      if (!address) return ''
      const { address1, address2, city, state, zipCode } = address
      return [address1, address2, city, state, zipCode].filter(item => item).join(',')
    },
    async verificationAddress () {
      try {
        this.toAddressValidationInfo = null
        this.verificationAddressLoading = true
        const data = await this.$store.dispatch('verificationAddress', {
          address: this.to
        })
        this.toAddressValidationInfo = data.data
        this.verificationAddressLoading = false
      } catch (err) {
        alert(err.message)
        this.verificationAddressLoading = false
      }
    },
    switchShippingService ({ serviceType }) {
      const [, channel = ''] = serviceType.split(' - ')
      const $labelPackageWidget = this.$refs['LabelPackageWidget']
      const actualService = this.shippingServices.find(service => service.value === serviceType)
      if (actualService) {
        $labelPackageWidget.shippingService = actualService.value
      } else {
        const shippingService = channel.toUpperCase().includes('MWT')
          ? `FEDEX_MWT - ${channel}`
          : serviceType.includes('GROUND_HOME_DELIVERY') ? serviceType.replace('GROUND_HOME_DELIVERY', 'FEDEX_GROUND') : serviceType
        $labelPackageWidget.shippingService = shippingService
      }
    },
    clearFromTemplate () {
      // reset from
      // if (!value) return
      this.fromTemplate = {}
    },
    toMoney,
    createAddress (addresses) {
      return this.$store.dispatch('labelCreateAddress', {addresses})
    },
    extractPayload () {
      const {
        from,
        to,
        order,
        isSupportDangerousGoods,
        dangerousGoods,
        hazMatsInfo,
        offerorName,
        dryIceDetail,
        emergencyContactNumber
      } = this

      let {
        packages,
        carrier,
        carriers,
        shipDate,
        shippingService,
        signature,
        memo,
        note,
        isSaturdayDelivery,
        labelStockType,
        pricingOption,
        packageType,
        reference,
        isHoldAtLocation,
        location
      } = this.$refs['LabelPackageWidget'].$$extractData()
      let {name, ...fromRest} = from
      let {address1, address2, ...rest} = to
      if (!this.currentShippingService.isSupportFromExt) {
        delete fromRest.extension
      }
      if (!this.currentShippingService.isSupportToExt) {
        delete rest.extension
      }
      const [serviceType, channel = 'GENERAL'] = shippingService.split(' - ')
      // 如果是copy按钮过来买label,则剔除多余数据（signature会报错）
      if (this.labelInfo.packages && this.labelInfo.packages.length) {
        packages = packages.map(({ signature, isMeasurementMetric, ...rest }) => rest)
      }
      packages = packages.map(pkg => {
        const {_key, ...rest} = pkg
        return rest
      })

      const payload = {
        packages: packages,
        from: fromRest,
        to: {
          ...rest,
          address1,
          address2: address2 || ''
        },
        shipDate,
        serviceType,
        channel,
        shippingService,
        signature,
        memo,
        note: note || this.labelNote || (order ? `Label for order ${order.orderId}` : ''),
        orderKey: order ? order._key : '',
        carrier,
        carriers,
        isMeasurementMetric: this.isMeasurementMetric,
        labelStockType,
        isSupportHazmat: isSupportDangerousGoods,
        accountId: from.siteId,
        reference
      }
      // location
      if (isHoldAtLocation) {
        payload.isHoldAtLocation = isHoldAtLocation
        payload.location = location
      }
      if (!payload.accountId) {
        delete payload.accountId
      }
      if (isSaturdayDelivery !== undefined) payload.isSaturdayDelivery = isSaturdayDelivery
      if (isSupportDangerousGoods) {
        payload.dangerousGoods = dangerousGoods
        const isBattery = dangerousGoods === 'BATTERY'
        if (isBattery) {
          Object.assign(payload, {
            hazMatsInfo,
            offerorName,
            emergencyContactNumber
          })
        } else if (dangerousGoods === 'LITHIUM_BATTERY') {
          if (this.isPrintSafetyDocument && !this.signatureCode) {
            throw Error('Please select signature file for dangerous goods.')
          }
          if (!payload.packages.some(item => item.lithiumBatteryOptions && item.lithiumBatteryOptions.length > 0)) {
            throw Error('Please select lithium battery options for at least one package.')
          }
          Object.assign(payload, {
            isSupportDangerousGoods,
            dangerousGoods,
            signatureCode: this.isPrintSafetyDocument && this.signatureCode ? this.signatureCode.downloadURL : null,
            isPrintSafetyDocument: this.isPrintSafetyDocument || false,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: item.lithiumBatteryOptions && item.lithiumBatteryOptions.length > 0,
                lithiumBatteryOptions: item.lithiumBatteryOptions || []
              }
            })
          })
        } else if (dangerousGoods === 'DRY_ICE') {
          Object.assign(payload, {
            dryIceDetail,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: false,
                lithiumBatteryOptions: []
              }
            })
          })
        } else {
          Object.assign(payload, {
            isSupportDangerousGoods,
            dangerousGoods,
            packages: packages.map(item => {
              return {
                ...item,
                isLithiumBattery: false,
                lithiumBatteryOptions: []
              }
            })
          })
        }
      } else {
        payload.packages = packages.map(item => {
          return {
            ...item,
            isLithiumBattery: false,
            lithiumBatteryOptions: []
          }
        })
      }
      if (pricingOption === PRICING_OPTIONS.ONE_RATE) {
        payload.packageType = packageType
        payload.pricingOption = pricingOption
      }

      // shipment
      if (this.products && Object.values(this.products).length) {
        const [value] = Object.values(this.products)
        payload.warehouseKey = value.warehouseKey
      } else if (this.forecastedPackages.length) {
        payload.warehouseKey = this.forecastedPackages[0].warehouseKey
      }
      return payload
    },
    async getRate () {
      this.isLoadingRates = true
      this.autoGetRateComplete = false
      this.errorMessage = ''
      this.rates = []
      this.recommendAddress = null
      try {
        // let maxPkgQty = this.isAutoGetRate ? 100 : this.serviceSetting.maxPkgQty
        let maxPkgQty = this.serviceSetting.maxPkgQty
        let pkgQty = this.packages.reduce((acc, pkg) => acc + pkg.qty, 0)
        if (!this.isAutoGetRate && pkgQty > maxPkgQty) {
          throw Error(`Package quantity are limited to ${maxPkgQty}.`)
        }
        this.validDangerousGoodsInfo()
        this.moreRates = []
        if (!this.$refs['formPopup'].validate()) return
        this.validDangerousGoodsInfo()
        this.errorMessage = ''
        this.deleteWarningMessage('address-ambiguous', 'recommend-address')
        let payload = this.extractPayload()
        this.systemBalance.discount && (payload.discount = this.systemBalance.discount)
        this.isLoadingRates = true
        let isAutoGetRate = payload.carriers.length > 0
        const rtn = await this.$store.dispatch('getRates', payload)
        // if (rtn.data.notMatch) {
        //   this.setWarningMessages('address-ambiguous', this.$t('notMatch'))
        // }
        if (rtn.data.isCleansed) {
          let {
            address1,
            city,
            state,
            zipCode
          } = rtn.data
          this.setWarningMessages('recommend-address', this.$t('recommendedRecipientAddress', { address: address1, city, state, zipCode }))
        }
        if (rtn.data.recommendAddress) {
          let {
            address1,
            address2,
            city,
            state,
            zipCode
          } = rtn.data.recommendAddress
          this.recommendAddress = { address1, address2, city, state, zipCode }
        }
        const {postageAmount, ...surcharges} = rtn.data.amountDetails
        const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
        const {carrier = 'usps', serviceType, serviceDescription, estimatedDelivery, originBaseCharge} = rtn.data
        let rate = {
          carrier,
          serviceType,
          serviceDescription,
          estimatedDelivery,
          hasResidentialCheck: false,
          rate: postageAmount,
          surcharge,
          originBaseCharge: originBaseCharge && Number(originBaseCharge),
          total: toMoney(surcharge + postageAmount)
        }
        if (rtn.data.moreRates?.length) {
          const {estimatedDelivery: estDelivery = null} = rtn.data
          this.rates = rtn.data.moreRates.map(({
            carrier = rtn.data.carrier || this.shippingService.carrier,
            serviceType,
            serviceDescription,
            amountDetails = {},
            estimatedDelivery = estDelivery,
            originBaseCharge,
            isResidential = !!rtn.data.isResidential,
            errCode = '',
            message = ''
          }) => {
            const {postageAmount, ...surcharges} = amountDetails
            const surcharge = Object.values(surcharges).reduce((a, b) => toMoney(a + b), 0)
            const actualService = this.shippingServices.find(service => service.value === serviceType)
            const actualServiceDescription = actualService ? actualService.text : serviceDescription
            return errCode || message ? {
              carrier,
              serviceType,
              serviceDescription: actualServiceDescription,
              errCode,
              message
            } : {
              carrier,
              serviceType,
              serviceDescription: actualServiceDescription,
              rate: postageAmount,
              hasResidentialCheck: true,
              isResidential,
              surcharge,
              total: toMoney(surcharge + postageAmount),
              estimatedDelivery,
              originBaseCharge: originBaseCharge && Number(originBaseCharge)
            }
          })
        } else if (rtn.data.totalAmount) { // non-fedex
          this.rates = [{...rate}]
        }
        if (isAutoGetRate) {
          this.autoGetRateComplete = true
          this.switchShippingService(this.rates[0])
        }
        if (rtn.data.errCode) {
          throw new Error(
            ((rtn.data.serviceDescription || '') +
            ' ' +
            rtn.data.message).trim()
          )
        }
      } catch (e) {
        let message = e.message
        if (message === 'There are no valid services available.') {
          message = this.$t('saturdayDeliveryError')
        }
        this.errorMessage = message
      } finally {
        this.isLoadingRates = false
      }
    },
    onSubmitted () {
      const pkgQty = this.packages.reduce((acc, pkg) => acc + pkg.qty, 0)
      if (pkgQty > this.serviceSetting.maxPkgQty) {
        throw Error(`Package quantity are limited to ${this.serviceSetting.maxPkgQty}.`)
      }
      if (['USPS', 'UPS_GROUND'].includes(this.shippingService) && pkgQty > 1) {
        throw Error('Selected provider does not support multiple packages.')
      }
      this.validDangerousGoodsInfo()
      const payload = this.extractPayload()
      if (!this.order) {
        delete payload.orderKey
      }
      let {isSupportDangerousGoods, isSaveFrom, isSaveTo, quantity, to, from} = this
      let {isAmazon: tempFlag, ...toRest} = to
      let {isAmazon, ...fromRest} = from
      let addressesToCreate = []
      isSaveTo && addressesToCreate.push(toRest)
      isSaveFrom && !isSupportDangerousGoods && addressesToCreate.push(fromRest)
      addressesToCreate.length && this.createAddress(addressesToCreate)
      this.errorMessage = ''

      const labels = (this.requestIdCache.length ? this.requestIdCache : this.idGenerator(quantity))
        .map(requestId => {
          const params = {
            ...payload,
            isMeasurementMetric: this.isMeasurementMetric,
            requestId
          }
          return params
        })
      return this.$store.dispatch('createLabels', labels)
        .then(rtn => {
          this.requestIdCache = []
          const {successLabels, errorLabels} = rtn
          this.$emit('submitted', successLabels
            .map(item => {
              return {
                ...item,
                createTime: new Date(),
                lastModifiedTime: new Date()
              }
            }))

          if (errorLabels.length > 0) {
            throw Error(errorLabels[0].message || `${successLabels.length} label(s) created successfully. ${errorLabels.length} failed. You can try recreating the rest of labels.`)
          }
        })
        .catch(error => {
          if (error.message === 'request-label-error') {
            this.errorMessage = this.$t('failedToRequestForLabel')
          } else if (error.message === 'endpoint-request-timed-out') {
            this.errorMessage = this.$t('endpointRequestTimedOut')
            this.requestIdCache = labels.map(item => item.requestId)
          } else if (error.message === 'SATURDAY_DELIVERY is not allowed for the origin/destination pair') {
            this.errorMessage = this.$t('saturdayDeliveryError')
          } else if (error.message === 'Package 1 - Invalid number of commodities in hazardous commodity content') {
            this.errorMessage = this.$t('invalidNumberOfHazmat')
          } else {
            this.errorMessage = error.data ? error.data.message : error.message
          }
          throw error
        })
    },
    deleteAddress (address) {
      if (!confirm('Are you sure to delete this address?')) return Promise.resolve()
      return this.$store.dispatch('labelDeleteAddress', address)
        .then(() => {
          if (this.from.siteName === address.siteName) {
            this.from = {}
          }
          if (this.to.siteName === address.siteName) {
            this.to = {}
          }
        })
    },
    setWarningMessages (key, value) {
      this.warningMessages[key] = value
    },
    deleteWarningMessage (...keys) {
      keys.forEach(key => {
        delete this.warningMessages[key]
      })
    },
    clearWarningMessages () {
      this.warningMessages = {}
    },
    formatEstDeliveryDate (str) {
      return (str === 'N/A' || !str) ? 'N/A' : this.toDateYYYYMMDD((new Date(str)))
    },
    goToGoogleMapLink () {
      gotoGoogleMap(this.to)
    },
    selectTemplate (e) {
      const {
        hazMatsInfo,
        dangerousGoods,
        emergencyContactNumber,
        offerorName,
        dryIceDetail = {},
        signatureCode
      } = e
      const params = {
        hazMatsInfo,
        dangerousGoods,
        emergencyContactNumber,
        offerorName,
        dryIceDetail
      }
      if (signatureCode && typeof signatureCode === 'string') {
        params.signatureCode = {
          downloadURL: signatureCode
        }
      } else {
        params.signatureCode = signatureCode || null
      }
      if (dangerousGoods && this.hasHazmatFeatures && !this.isSupportHazmat) {
        // this.clearFromTemplate(true)
        this.isSupportHazmat = true
      }
      Object.assign(this, params)
    },
    validDangerousGoodsInfo () {
      const {
        isSupportDangerousGoods,
        hazMatsInfo,
        dangerousGoods,
        packages,
        shippingService,
        labelServices,
        dryIceDetail: {
          weight,
          unit
        }
      } = this
      if (!isSupportDangerousGoods) return

      const isSupportHazmatService = labelServices.some(service => {
        const serviceType = service.serviceTypes.find(serviceType => shippingService === serviceType.value)
        return serviceType && serviceType.isSupportDangerousGoods
      })
      if (!isSupportHazmatService) throw Error(this.$t('shippingServiceNotSupportDangerousGoods'))

      const isBattery = dangerousGoods === 'BATTERY'
      if (isBattery) {
        if (hazMatsInfo.length < 1) throw Error(this.$t('fillInAtLeastOneHazMatInformation'))
        if (this.$refs.HazardousCommodities.totalBatteryWeight > packages[0].weightLb) throw Error(this.$t('dangerousGoodsExceedsWeight'))
      }
      if (dangerousGoods === 'DRY_ICE' && packages[0].weightLb < +this.convertWeight(weight, unit === 'KG')) {
        throw Error(this.$t('dangerousGoodsExceedsWeight'))
      }
    },
    showParseAddressPopup (target) {
      // 内存中有缓存则不需要再次下载文件
      !Object.keys(this.allCities).length && this.getAllCities()
      this.target = target
      this.isShowParseAddressPopup = true
    },
    parseAddressStr () {
      if (!this.originAddress) {
        this.parseErrorMessage = this.$t('fullAddressShouldNotBeEmpty')
        return
      }
      // 将可能存在的很多换行，整合为一行传入分析
      const address = this.originAddress.replace(/(\n|\t|,)+/mg, ' ')

      try {
        this.parseErrorMessage = ''
        this.parseAddressData = parseAddress(this.allCities, address)
        let parts = this.originAddress.replace(/(\n|\t|,)+/mg, '$').split('$')
        if (parts.length > 1 && !parts[0].match(/^\d+/)) {
          this.$set(this.parseAddressData, 'fullName', parts[0])
          parts.splice(0, 1)
        }

        if (parts.length > 1 && !parts[0].match(/^\d+/)) {
          this.$set(this.parseAddressData, 'company', parts[0])
          parts.splice(0, 1)
        }
      } catch (error) {
        this.parseErrorMessage = `${this.$t('currentAddressFormatCanNotBeRecognized')} \n (${this.$t('example')}: 55 E 11th St Unit ABC Washington DC 20500)`
      }
    },
    applyData () {
      Object.assign(this.target, this.parseAddressData)
      this.isShowParseAddressPopup = false
      this.closePopupAndResetData()
    },
    closePopupAndResetData () {
      this.isShowParseAddressPopup = false
      this.originAddress = ''
      this.parseErrorMessage = ''
      this.parseAddressData = {}
    },
    getAllCities () {
      return this.$store.dispatch('getAllCities')
    },
    useRecommendAddress () {
      if (!this.recommendAddress) return
      const { address1, address2, city, state, zipCode } = this.recommendAddress
      Object.assign(this.to, {
        address1,
        address2,
        city,
        state,
        zipCode
      })
    }
  },
  props: {
    value: Boolean,
    idGenerator: Function,
    initTemplate: {
      type: Object,
      default: () => {
        return {}
      }
    },
    onlyOneLabel: Boolean,
    order: Object,
    initTo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    labelInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isFreight: Boolean,
    products: {
      type: Object,
      default: () => {
        return null
      }
    },
    forecastedPackages: {
      type: Array,
      default: () => []
    },
    businessType: {
      type: String,
      default: 'domestic'
    }
  }
}
</script>

<style>

.checkbox {
  margin-bottom: 0px;
  position: relative;
  top: 12px;
}

.labelPopup .v-card__text {
  padding-top: 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/LabelCreatePopup.vue